import Document from "../general/document";

export interface UserData {
  name: string;
  phone: string;
  invitation: string;
}

class User extends Document<UserData> {
  get name() {
    return this.data.name;
  }
}

export default User;
